export const NOT_INCLUDED_TEXT =
  "Non-reimbursable expenses are not included in the scheduled payment";
